import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ParentEventFromSearch } from "../../admin/events-screen/event-page-models/parent-event-from-search";

import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NoalGlobalData } from "../../_services/eventsServices/events.service";

@Component({
  selector: "generic-auto-complete",
  templateUrl: "generic-auto-complete.component.html",
  styleUrls: ["generic-auto-complete.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          height: "500px",
          maxHeight: "2000px",
          overflow: "visible",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class GenericAutoCompleteComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("formTabSet") public formTabSet: NgbTabset;
  @Input("noalGlobalData") public noalGlobalData: NoalGlobalData;

  private parentEvent: ParentEventFromSearch;

  constructor() {}

  public ngOnInit(): void {}

  // tslint:disable-next-line:no-empty
  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  submit() {}
}



// WEBPACK FOOTER //
// ./src/app/form/generic-auto-complete/generic-auto-complete.component.ts